import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { motion as m } from "framer-motion";

const FOREST =
    "https://images.unsplash.com/photo-1663856542282-bf5647286f63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxwaW5lJTIwZm9yZXN0JTIwdmFsbGV5JTIwYWVyaWFsJTIwd2luZGluZyUyMHJvYWR8ZW58MHx8fHwxNzkwMjcxNjY2fDA&ixlib=rb-4.1.0&q=85";

const EASE = [0.16, 1, 0.3, 1];

const lineVariants = {
    hidden: { y: "115%" },
    visible: (i) => ({
        y: "0%",
        transition: { duration: 1.15, ease: EASE, delay: i * 0.16 },
    }),
};

export default function TrailSection() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });
    const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

    return (
        <section
            ref={ref}
            data-testid="trail-section"
            className="relative flex min-h-[92vh] items-center overflow-hidden"
        >
            <motion.div style={{ y }} className="absolute inset-0 scale-[1.22]">
                <img
                    src={FOREST}
                    alt="A winding road through a pine forest valley"
                    className="h-full w-full object-cover"
                />
            </motion.div>
            <div className="absolute inset-0 bg-gradient-to-b from-[#0B1612] via-[#0B1612]/50 to-[#0B1612]" />

            <div className="relative z-10 w-full px-6 py-28 md:px-12">
                <m.p
                    className="mb-8 flex items-center gap-4"
                    initial={{ opacity: 0, x: -24 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.9, ease: EASE }}
                >
                    <span className="h-px w-10 bg-[#D4AF37] md:w-14" />
                    <span className="font-mono-mm text-[0.65rem] uppercase tracking-[0.32em] text-[#D4AF37] md:text-xs">
                        Talk soon
                    </span>
                </m.p>
                <m.blockquote
                    data-testid="trail-quote"
                    className="font-display text-[clamp(2.1rem,5.4vw,4.9rem)] font-medium italic leading-[1.12] tracking-tight text-[#F5F5F0]"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.35 }}
                >
                    {["\u201CSomething good is", "on the road again.\u201D"].map((line, i) => (
                        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
                            <m.span
                                className="block will-change-transform"
                                custom={i}
                                variants={lineVariants}
                            >
                                {line}
                            </m.span>
                        </span>
                    ))}
                </m.blockquote>
                <m.p
                    className="mt-9 font-mono-mm text-[0.65rem] uppercase tracking-[0.32em] text-[#A3B8AD] md:text-xs"
                    initial={{ opacity: 0, y: 18 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.9, ease: EASE, delay: 0.4 }}
                >
                    See you down the trail
                </m.p>
            </div>
        </section>
    );
}
